import React from 'react';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

type PathItem = {
  id: number;
  type: 'group' | 'category';
  name: string;
};

type Props = {
  path: PathItem[];
  onClick: (index: number) => void;
};

const Breadcrumb: React.FC<Props> = ({ path, onClick }) => (
  <div className="flex items-center mb-6 text-sm">
    <button
      onClick={() => onClick(-1)}
      className="text-gray-400 hover:text-white flex items-center"
    >
      <HomeIcon className="h-4 w-4 mr-1" />
      <span>Home</span>
    </button>
    {path.map((item, index) => (
      <div key={`${item.type}-${item.id}`} className="flex items-center">
        <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-500" />
        <button
          onClick={() => onClick(index)}
          className={index === path.length - 1 ? 'text-destiny-gold' : 'text-gray-400 hover:text-white'}
        >
          {item.name}
        </button>
      </div>
    ))}
  </div>
);

export default Breadcrumb;
